import {EU_COUNTRY_LIST, FE_COUNTRY_LIST, SUPERNOVA_DOMAIN} from "src/constants/constants";


const redirect = async (country: string) => {
    if (EU_COUNTRY_LIST.includes(country)) {
        window.location.replace( `https://gamma.eu.${SUPERNOVA_DOMAIN}`);
    } else if (FE_COUNTRY_LIST.includes(country)) {
        window.location.replace( `https://gamma.fe.${SUPERNOVA_DOMAIN}`);
    } else {
        window.location.replace( `https://gamma.na.${SUPERNOVA_DOMAIN}`);
    }
}

export default {redirect};

